import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Form } from 'antd';
import { FieldData } from 'rc-field-form/es/interface';
import { appConfig } from '../../../settings';
import { IEditForm, IRateInfo, RareFormTab } from '../../../interfaces';
import { useRateInfo } from '../../../hooks';
import {
    addRateChangedFormTab,
    apiMessagesSaveMessagesV2,
    cleanApiMessages,
    removeRateChangedFormTab,
    sendRateDataInfoV2,
    setRateForm,
} from '../../../middleware';
import { debounce, onFormFieldsChange } from '../../../instruments';
import { Catcher } from '../../../Components';
import { EditRateFieldsInfo } from './../Components';

export const EditRateFormInfoV2: React.FC<IEditForm> = observer(
    ({ setEditMode, isNew = false, loadingTypes, isDisabledSave }: IEditForm) => {
        const initialInfo = useRateInfo();

        const initialValues: IRateInfo = { ...initialInfo };
        const [form] = Form.useForm();
        const [isSending, setSending] = useState(false);
        const checkValid = (): void => {
            form.validateFields();
        };

        useEffect(() => {
            form.setFieldsValue(initialInfo);
            checkValid();
        }, [initialInfo]);

        const onValuesChange = (changedFields: FieldData[]): void => {
            addRateChangedFormTab(RareFormTab.INFO);
            onFormFieldsChange({
                changedFields,
                initialValues,
                setForm: setRateForm,
                checkValid,
            });
        };

        const saveRate = async (): Promise<void> => {
            cleanApiMessages();
            setSending(true);
            const rateDataInfo = form.getFieldsValue();
            const { isError, errors = [] } = await sendRateDataInfoV2(isNew, rateDataInfo);
            if (isError) {
                apiMessagesSaveMessagesV2(errors);
                checkValid();
            } else {
                setEditMode && setEditMode(false);
            }
            removeRateChangedFormTab(RareFormTab.INFO);
            setSending(false);
        };

        return (
            <Catcher>
                <Form
                    className={'formStyle'}
                    form={form}
                    initialValues={initialValues}
                    layout={'vertical'}
                    name="salesRateListInfo"
                    onValuesChange={debounce(onValuesChange, appConfig.delayFormUpdateState)}
                    scrollToFirstError={true}
                >
                    <EditRateFieldsInfo
                        isDisabledSave={isDisabledSave}
                        isNew={isNew}
                        isSending={isSending}
                        loadingTypes={loadingTypes}
                        save={saveRate}
                        setEditMode={setEditMode}
                    />
                </Form>
            </Catcher>
        );
    },
);
